//民宿管理
export default [
  {
    path: '/minsusManage',
    component: () => import('../pages/homestay/minsusManage.vue'),
    name: 'minsusManage',
    title: '民宿管理',
    meta: {
      title: '民宿管理',
    },
  },
  {
    path: '/addHomestay',
    component: () => import('../pages/homestay/addHomestay.vue'),
    name: 'addHomestay',
    title: '新增民宿管理',
    meta: {
      title: '新增民宿管理',
    },
  },
  {
    path: '/homestayInfo',
    component: () => import('../pages/homestay/homestayInfo.vue'),
    name: 'homestayInfo',
    title: '民宿详情',
    meta: {
      title: '民宿详情',
    },
  },
  {
    path: '/setMinSuPrice',
    component: () => import('../pages/homestay/setMinSuPrice.vue'),
    name: 'setMinSuPrice',
    title: '设置售价',
    meta: {
      title: '设置售价',
    },
  },
  {
    path: '/minsuFacilities',
    component: () => import('../pages/homestay/minsuFacilities.vue'),
    name: 'minsuFacilities',
    title: '民宿设施管理',
    meta: {
      title: '民宿设施管理',
    },
  },
  {
    path: '/hotelFacilitiesCategory',
    component: () => import('../pages/homestay/hotelFacilitiesCategory.vue'),
    name: 'hotelFacilitiesCategory',
    title: '民宿设施类型',
    meta: {
      title: '民宿设施类型',
    },
  },
  {
    path: '/hotelBasicAttribute',
    component: () => import('../pages/homestay/hotelBasicAttribute.vue'),
    name: 'hotelBasicAttribute',
    title: '基本属性',
    meta: {
      title: '基本属性',
    },
  },
  {
    path: '/getInfo',
    component: () => import('../pages/homestay/orderMinsu.vue'),
    name: 'getInfo',
    title: '列表订单',
    meta: {
      title: '列表订单',
    },
  },
  {
    path: '/minsuCheckin',
    component: () => import('../pages/homestay/minsuCheckin.vue'),
    name: 'minsuCheckin',
    title: ' 办理入住',
    meta: {
      title: ' 办理入住',
    },
  },
  {
    path: '/appraiseManage',
    component: () => import('../pages/homestay/appraiseManage.vue'),
    name: 'appraiseManage',
    title: '评价管理',
    meta: {
      title: '评价管理',
    },
  },
  {
    path: '/minsuContent',
    component: () => import('../pages/homestay/minsuContent.vue'),
    name: 'minsuContent',
    title: '民宿概况',
    meta: {
      title: '民宿概况',
    },
  },
  {
    path: '/minsuReco',
    component: () => import('../pages/homestay/minsuReco.vue'),
    name: 'minsuReco',
    title: '民宿推荐',
    meta: {
      title: '民宿推荐',
    },
  },
]
